// eslint-disable-next-line import/no-anonymous-default-export
export default /* glsl */`

// create variables of the base UV map for different maps

	varying vec2 mapUv;

	varying vec2 bumpMapUv;
	uniform mat3 bumpMapUvTransform;

	varying vec2 normalMapUv;
	uniform mat3 normalMapUvTransform;

	varying vec2 alphaMapUv;
	uniform mat3 alphaMapUvTransform;

	varying vec2 emissiveMapUv;
	uniform mat3 emissiveMapUvTransform;

	varying vec2 roughnessMapUv;
	uniform mat3 roughnessMapUvTransform;

	varying vec2 metalnessMapUv;
	uniform mat3 metalnessMapUvTransform;

	attribute vec2 uv2;
	varying vec2 vUv2;
	uniform mat3 uv2Transform;

`;